import Component from "../../component";
import {StampedIoConfig} from "../../stamped_io/stamped_io_config";

export const RewardsCounterConfig = {
    signature: 'rewardsCounter',
    baseHtmlClass: 'rewards_counter',
    selector: '.rewards_counter',
    initedHtmlClassModifier: 'inited',
    emptyHtmlClassModifier: 'empty',
};

export class RewardsCounter extends Component {

    static applyToAll() {
        document.querySelectorAll(RewardsCounterConfig.selector).forEach((element) => {
            if (!RewardsCounter.isElementComponentized(element, RewardsCounterConfig.signature)) new RewardsCounter(element);
        });
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: RewardsCounterConfig
        });

        this.extractData();

        document.addEventListener(StampedIoConfig.launcherLoadedEventName, this.handlePotentialDataChange.bind(this));
        document.addEventListener(StampedIoConfig.rewardsRedeemedEventName, this.handlePotentialDataChange.bind(this));

        this.inited = true;
        this.render();
    }

    handlePotentialDataChange() {
        this.extractData();
        this.render();
    }

    extractData() {
        this.counterValue = this.extractCounterValue();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, RewardsCounterConfig.initedHtmlClassModifier);
        this.conditionallySetHtmlClassState(this.isEmpty(), RewardsCounterConfig.emptyHtmlClassModifier);
        this.element.innerHTML = (this.hasCounterValue() ? `${this.counterValue}` : ``);
    }

    isEmpty() {
        if (!this.hasCounterValue()) return true;
        if (this.counterValue === 0) return true;
        return false;
    }

    hasCounterValue() {
        return this.counterValue !== null;
    }

    extractCounterValue() {
        if (!window.StampedFn || !window.StampedFn.getDataRewards) return null;
        const data = window.StampedFn.getDataRewards();
        let value = parseInt(data?.points?.points);
        if (Number.isNaN(value)) return null;
        return value;
    }

}
